import { createRouter, createWebHistory } from "vue-router";
import Login from "../views/Login.vue";
import User from "../views/User.vue";
import Dashboard from "../views/patient/Dashboard.vue";
import Profile from "../views/patient/Profile.vue";
import Records from "../views/patient/Records.vue";
import Versions from "../views/patient/Versions.vue";
import ContactUs from "../views/patient/ContactUs.vue";
import Doctor from "@/views/Doctor.vue";
import DashboardDoctor from "@/views/doctor/Dashboard-Doctor.vue";
import ProfileDoctor from "@/views/doctor/Profile-Doctor.vue";
import PatientsList from "@/views/doctor/Patients-List.vue";
import AddPatient from "@/views/doctor/Add-Patient.vue";
import Admin from "@/views/Admin.vue";
import DashboardAdmin from "@/views/admin/DashboardAdmin.vue";
import ProfileAdmin from "@/views/admin/ProfileAdmin.vue";
import AddDoctor from "@/views/admin/AddDoctor.vue";
import AddPatients from "@/views/admin/AddPatient.vue";
import DrPatientConnection from "@/views/admin/DrPatientConnection.vue";
import CreateVersion from "@/views/doctor/CreateVersion.vue";
import ShowRecordPatient from "@/views/doctor/ShowRecordPatient.vue";
import store from "@/store";
const routes = [
  {
    path: "/",
    name: "login",
    component: Login,
    logoutRequaierd: true,
  },
  {
    path: "/user",
    name: "user",
    component: User,
    meta: {
      isAutnticated: false,
    },
    children: [
      {
        path: "/patient/dashboard",
        name: "patient-dashboard",
        component: Dashboard,
        meta: {
          isAutnticated: false,
        },
      },
      {
        path: "/patient/profile",
        name: "patient-profile",
        component: Profile,
        meta: {
          isAutnticated: false,
        },
      },
      {
        path: "/patient/records",
        name: "patient-records",
        component: Records,
        meta: {
          isAutnticated: false,
        },
      },
      {
        path: "/patient/versions",
        name: "versions",
        component: Versions,
        meta: {
          isAutnticated: false,
        },
      },
      {
        path: "/contact-us",
        name: "contactus",
        component: ContactUs,
        meta: {
          isAutnticated: false,
        },
      },
    ],
  },
  {
    path: "/doctor",
    name: "doctor",
    component: Doctor,
    meta: {
      isAutnticated: false,
    },
    children: [
      {
        path: "/doctor/dashboard",
        name: "dashboard-doctor",
        component: DashboardDoctor,
        meta: {
          isAutnticated: false,
        },
      },
      {
        path: "/doctor/profile",
        name: "profile-doctor",
        component: ProfileDoctor,
        meta: {
          isAutnticated: false,
        },
      },
      {
        path: "/doctor/patients",
        name: "patients-list",
        component: PatientsList,
        meta: {
          isAutnticated: false,
        },
      },
      {
        path: "/doctor/add-patient",
        name: "add-patient",
        component: AddPatient,
        meta: {
          isAutnticated: false,
        },
      },
      {
        path: "/contact",
        name: "contact-us",
        component: ContactUs,
        meta: {
          isAutnticated: false,
        },
      },
      {
        path: "/doctor/patients-records",
        name: "patients-records",
        component: ShowRecordPatient,
        props: true,
        meta: {
          isAutnticated: false,
        },
      },
      {
        path: "/doctor/patients-versions",
        name: "patients-versions",
        component: CreateVersion,
        props: true,
        meta: {
          isAutnticated: false,
        },
      },
    ],
  },
  {
    path: "/admin",
    name: "admin",
    component: Admin,
    meta: {
      isAutnticated: false,
    },
    children: [
      {
        path: "/admin/dashboard",
        name: "dashboard-admin",
        component: DashboardAdmin,
        meta: {
          isAutnticated: false,
        },
      },
      {
        path: "/admin/profile",
        name: "profile-admin",
        component: ProfileAdmin,
        meta: {
          isAutnticated: false,
        },
      },
      {
        path: "/admin/add-patient",
        name: "add-patients",
        component: AddPatients,
        meta: {
          isAutnticated: false,
        },
      },
      {
        path: "/admin/add-doctor",
        name: "add-doctor",
        component: AddDoctor,
        meta: {
          isAutnticated: false,
        },
      },
      {
        path: "/admin/dr-patient-connection",
        name: "dr-patinet-connection",
        component: DrPatientConnection,
        meta: {
          isAutnticated: false,
        },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
router.beforeEach((to) => {
  console.log(store.state.isLogin);
  if (to.meta.isAutnticated && !store.state.isLogin) {
    return {
      path: "/",
      query: { redirect: to.fullPath },
    };
  } else if (to.meta.logoutRequaierd && store.state.isLogin) {
    return {
      path: "/",
      query: {
        redirect: to.fullPath,
      },
    };
  }
});
export default router;
